import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BottomBar from "./CartDetailsComponent/BottomBar";
import AddProductModal from "./CartDetailsComponent/AddProductModal";
import DefaultQuotationTable from "./CartDetailsComponent/DefaultCartTable";
import Button from "../../components/Button";
import FileDownloadIcon from "../../assets/svg-tsx/FileDownloadIcon";
import ProjectQuotationTable from "./CartDetailsComponent/ProjectCartTable";
import loadingSpinner from "../../assets/images/LoadingSpinner.gif";
import { checkPermissions, formatDate, formatDate1 } from "../../utils/helper";
import { protectedAxiosInstance } from "../../api/axiosManagement";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userInfoAtom } from "../../atom";
import LegendList from "../Quotation/components/LegenList";
import {
  getAbandonedCartDetailsItems,
  getShareableToken,
  getSingleCartDetails,
  getSingleProjectDetails,
} from "../../api/abandonedCart";

const AbandonedCartDetails = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [openFloorAreaModal, setOpenFloorAreaModal] = useState(false);
  const [showProfessionalModal, setShowProfessionalModal] = useState(false);
  const [singleQuotationLoading, setSingleQuotationLoading] = useState(false);
  const [singleCartData, setSingleCartData] = useState<any>([]);

  const [singleProjectData, setSingleProjectData] = useState<any>([]);

  const [cost, setCost] = useState<any>(0);
  const [costLoading, setCostLoading] = useState(false);
  const [cartCheckoutData, setCartCheckoutData] = useState<any>([]);
  const [downloading, setDownLoading] = useState(false);
  const [discount, setDiscount] = useState("");
  const [name, setName] = useState("");
  const [cartItemsLoading, setCartItemsLoading] = useState(false);

  // default cart states
  const [pageLoading, setPageLoading] = useState(false);
  const [cartSpecificData, setCartSpecificData] = useState<any>([]);
  const [showBanner, setShowBanner] = useState(false);
  const [checkout, enableCheckout] = useState(false);
  const [projectSelectionIndex, setProjectSelectionIndex] = useState(null);
  const isAuthenticated = true;
  const [bottomBarHeight, setBottomBarHeight] = useState(0); // State to track bottom bar height
  const [cartSpecificProjectData, setCartSpecificProjectData] = useState<any>(
    []
  );
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const { id: cartId } = useParams();
  const [selectedProfessional, setSelectedProfessional] = useState<any>(null);

  // Permission
  const hasViewPermission = checkPermissions(
    "view_abandoned_cart",
    true,
    toast
  );
  const hasEditPermission = checkPermissions("edit_abandoned_cart");

  const userInfo = useRecoilValue(userInfoAtom);

  async function getSingleQuotation(id: any) {
    setSingleQuotationLoading(true);
    return getSingleCartDetails(id)
      .then((res: any) => {
        setSingleCartData(res?.data);
        setSelectedProfessional(res?.data?.professional);
        setDiscount(res?.data?.discount_percentage);
        setName(res?.data?.name);
      })
      .catch((error) => {
        if (error.status === 404) {
          toast.error(error?.data?.errors);
          navigate("/abandoned-cart");
        }
        console.error("Error fetching quotation details: ", error);
      })
      .finally(() => {
        setSingleQuotationLoading(false);
      });
  }

  async function getSingleProjectData(id: any) {
    return getSingleProjectDetails(id)
      .then((res: any) => {
        setSingleProjectData(res?.data);
      })
      .catch((error: any) => {
        console.error("Error fetching project details: ", error);
      })
      .finally(() => {});
  }

  useEffect(() => {
    if (singleCartData?.owner === "PROJECT") {
      getSingleProjectData(cartId);
    }
  }, [cartId, singleCartData]);

  async function getSingleQuotationCartItems(id: any) {
    setCartItemsLoading(true);
    return getAbandonedCartDetailsItems(id)
      .then((res: any) => {
        if (!res?.data?.floors?.[0]?.id) {
          setCartSpecificData(res.data?.floors?.[0]?.areas?.[0]?.items);
          setCartCheckoutData({
            line_items: res?.data?.floors?.[0]?.areas?.[0]?.items?.map(
              (el: any) => el.id
            ),
          });
          calculateCost(res?.data?.floors?.[0]?.areas?.[0]?.items);
        }

        if (res?.data?.floors?.[0]?.id) {
          const allItemsFlat: any = [];
          const allItems = res?.data?.floors?.map((floor: any, index: any) => {
            const allFloors = floor?.areas?.map((area: any, index: any) => {
              area?.items?.map((item: any, index: any) => {
                allItemsFlat.push(item);
              });
            });
          });
          setCartCheckoutData({
            line_items: allItemsFlat.map((el: any) => el.id),
          });
          setCartSpecificProjectData(res?.data?.floors);
          calculateCost(allItemsFlat);
        }

        if (res?.data?.floors.length === 0) {
          setCartSpecificProjectData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching quotation items: ", error);
      })
      .finally(() => {
        setCartItemsLoading(false);
      });
  }

  useEffect(() => {
    if (cartId) {
      getSingleQuotation(cartId);
    }
  }, [cartId]);

  useEffect(() => {
    if (singleCartData && cartId) {
      getSingleQuotationCartItems(cartId);
    }
  }, [cartId, singleCartData]);

  function AddProductHandler() {
    getShareableToken(cartId)
      .then((res: any) => {
        const token = res?.data?.shareable_token;
        const fullUrl = `${
          process.env.REACT_APP_DOMAIN
        }/hybec-lights?cartId=${
          singleCartData?.id
        }&shareableTokenCart=${token}${
          singleCartData?.owner === "PROJECT"
            ? `&isProjectAbandoneCart=true`
            : ""
        }`;
        // Ensure URL is defined and valid
        if (fullUrl) {
          window.location.href = fullUrl;
        }
      })
      .catch((error: any) => {
        toast.error(error?.data?.errors);
      });
  }

  // default cart functions
  function calculateCost(currentData: any = null) {
    setCostLoading(true);
    const payload: any = {};

    if (currentData) {
      payload.items = currentData.map((el: any) => (el.id ? el.id : el));
    } else if (
      cartCheckoutData?.line_items &&
      cartCheckoutData.line_items.length !== 0
    ) {
      payload.items = cartCheckoutData.line_items;
    } else {
      setCost(null);
      setCostLoading(false);
      return;
    }

    if (selectedProfessional) {
      payload.professional_id = selectedProfessional?.id;
      payload.professional_kind = selectedProfessional?.kind;
    }

    if (payload?.items?.length !== 0) {
      protectedAxiosInstance
        .post(`/admin/cart/${cartId}/checkout/calculate-cost`, payload)
        .then((res: any) => {
          setCost(res?.data?.data);
          setCostLoading(false);
        })
        .catch((err) => {
          setCost(null);
          setCostLoading(false);
        });
    } else {
      setCost(null);
      setCostLoading(false);
    }
  }

  useEffect(() => {
    calculateCost();
  }, [selectedProfessional]);

  function handleDeleteProfessional() {
    setSelectedProfessional(null);
    protectedAxiosInstance
      .put(`/admin/cart/${cartId}`, {
        professional_id: null,
        professional: null,
      })
      .then((res: any) => {
        getSingleQuotation(cartId);
        setShowProfessionalModal(false);
      })
      .catch((error) => {
        toast.error(error?.data?.errors?.professional_id?.[0]);
        setShowProfessionalModal(false);
      });
  }

  function downloadQuotation(theme: string) {
    setDownLoading(true);
    const parameters: any = {
      fileType: "pdf",
      theme: theme,
    };

    protectedAxiosInstance
      .get(`/admin/cart/${cartId}/download`, {
        responseType: "blob",
        params: parameters,
      })
      .then((res: any) => {
        const href = URL.createObjectURL(res?.data);
        const link = document.createElement("a");
        link.href = href;
        link.target = "_blank";
        const fileName =
          "Abandoned Cart -" + (singleCartData?.customer_name || "");
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        setDownLoading(false);
      })
      .catch((error: any) => {
        setDownLoading(false);
      });
  }

  if (singleQuotationLoading) {
    return (
      <div className="h-[70vh] flex justify-center items-center">
        <div className="text-md font-medium text-gray-900 bg-white rounded-lg inline-flex items-center gap-3">
          <img src={loadingSpinner} alt="spinner" className="h-auto w-[10vh]" />
        </div>
      </div>
    );
  }
  // total areas
  const totalAreas = singleProjectData?.project?.floors?.reduce(
    (sum: any, floor: any) => sum + floor?.areas?.length,
    0
  );

  const disableButton =
    downloading ||
    ((cartSpecificData === undefined || cartSpecificData?.length === 0) &&
      (cartSpecificProjectData === undefined ||
        cartSpecificProjectData?.length === 0));

  if (!hasViewPermission) {
    navigate("/abandoned-cart");
  }

  return (
    <div className="h-[calc(100dvh-40px)] flex flex-col justify-between items-start relative ">
      <div className="h-full w-full">
        <div className="flex flex-col">
          {/* Project Details Section */}
          <div className="border-b border-gray-200 px-6 text-[#1c1c1c] grid grid-cols-1">
            {singleCartData?.owner === "PROJECT" && (
              <div className="flex flex-row">
                <div className="border-r border-gray-200 py-2.5 w-[50%]">
                  <h2 className="text-black font-gilroy-bold text-xs leading-5 mb-4">
                    Project Details
                  </h2>

                  <div className="flex gap-[60px] text-xs text-[#1C1C1C] leading-5">
                    <div className="flex flex-col gap-3">
                      <div className="flex items-center">
                        <p>Project Name : </p>
                        <p className="font-gilroy-medium pl-2">
                          {singleProjectData?.project?.name || "-"}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <p>Date created : </p>
                        <p className="font-gilroy-medium pl-2">
                          {formatDate1(
                            singleProjectData?.project?.created_at
                          ) || "-"}
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-col gap-3">
                      <div className="flex items-center">
                        <p>Total floors : </p>
                        <p className="font-gilroy-medium pl-2">
                          {singleProjectData?.project?.floors?.length || "-"}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <p>Total areas : </p>
                        <p className="font-gilroy-medium pl-2">
                          {totalAreas || "-"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start justify-start flex-row ">
                      <p>Location : </p>
                      <p className="font-gilroy-medium pl-2">
                        {`${singleProjectData?.project?.address_city || ""}${
                          singleProjectData?.project?.address_city &&
                          singleProjectData?.project?.address_state
                            ? ", "
                            : ""
                        }${singleProjectData?.project?.address_state || "-"}`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="py-2.5 mx-4 w-[40%]">
                  <p className="text-xs text-black leading-5 font-gilroy-semi-bold mb-4">
                    Cart info
                  </p>
                  <div className="w-full flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex gap-2.5 items-center">
                        <p className="text-xs text-[#1C1C1C] leading-5">
                          Items Count:{" "}
                          <span className="text-black font-gilroy-medium">
                            {singleCartData?.count_items || "-"}
                          </span>
                        </p>
                      </div>

                      <div className="flex gap-2.5 items-center mt-1">
                        <div className="flex flex-row">
                          <p className="text-xs  text-[#1C1C1C] leading-5 mt-1">
                            Created At:{" "}
                            <span className="text-black font-gilroy-medium">
                              {formatDate(singleCartData?.created_at) || "-"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {singleCartData?.owner !== "PROJECT" && (
              <div className="flex flex-row">
                <div className="w-[50%] py-2.5">
                  <p className="text-xs text-black leading-5 font-gilroy-semi-bold">
                    Cart info
                  </p>
                  <div className="w-full flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex gap-2.5 items-center mt-3">
                        <p className="text-xs text-[#1C1C1C] leading-5">
                          Items Count:{" "}
                          <span className="text-black font-gilroy-medium">
                            {singleCartData?.count_items || "-"}
                          </span>
                        </p>
                      </div>

                      <div className="flex gap-2.5 items-center mt-3">
                        <div className="flex flex-row">
                          <p className="text-xs  text-[#1C1C1C] leading-5 mt-1">
                            Created At:{" "}
                            <span className="text-black font-gilroy-medium">
                              {formatDate(singleCartData?.created_at) || "-"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-full w-[0.5px] bg-gray-200"></div>
                <div className="py-2.5 mx-4">
                  <div className="w-full flex flex-row">
                    <div className="flex flex-col">
                      <p className="text-xs text-black leading-5 font-gilroy-semi-bold">
                        Customer info
                      </p>
                      <div className="flex gap-2.5 items-center mt-3">
                        <p className="text-xs text-[#1C1C1C] leading-5">
                          Customer Name:{" "}
                          <span className="text-black font-gilroy-medium">
                            {singleCartData?.customer_name || "-"}
                          </span>
                        </p>
                      </div>

                      <div className="flex gap-2.5 items-center mt-3">
                        <div className="flex flex-row">
                          <p className="text-xs  text-[#1C1C1C] leading-5 mt-1">
                            Customer Phone:{" "}
                            <span className="text-black font-gilroy-medium">
                              {singleCartData?.customer_phone
                                ?.replace(/\D/g, "")
                                .replace(/^91/, "+91 ")
                                ?.replace(/(\d{5})(\d{5})/, "$1 $2") || "-"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="w-full flex items-center justify-between flex-row gap-4 h-[52px] px-4">
          <LegendList />

          <div className="flex flex-row gap-4 items-center justify-center">
            <Button
              variant="secondary"
              label="Arcz"
              leftIcon={<FileDownloadIcon color="#FFFFFF" />}
              onClick={() => {
                downloadQuotation("arcz");
              }}
              disabled={disableButton}
              className="!h-8"
            />
            <Button
              variant="secondary"
              leftIcon={<FileDownloadIcon color="#FFFFFF" />}
              label="Luminarist"
              onClick={() => {
                downloadQuotation("luminarist");
              }}
              disabled={disableButton}
              className="!h-8"
            />
            <Button
              variant="secondary"
              leftIcon={<FileDownloadIcon color="#FFFFFF" />}
              label="Perfect Lights"
              onClick={() => {
                downloadQuotation("pl");
              }}
              disabled={disableButton}
              className="!h-8"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          {(singleCartData?.owner === "USER" ||
            singleCartData?.owner === "ANON") &&
            cartId && (
              <DefaultQuotationTable
                loading={
                  singleQuotationLoading ||
                  (cartItemsLoading && !cartSpecificData?.length)
                }
                data={cartSpecificData}
                calculateCost={calculateCost}
                showBanner={showBanner}
                enableCheckout={enableCheckout}
                projectSelectionIndex={projectSelectionIndex}
                setProjectSelectionIndex={setProjectSelectionIndex}
                cartSpecificData={cartSpecificData}
                setCartSpecificData={setCartSpecificData}
                isAuthenticated={isAuthenticated}
                bottomBarHeight={bottomBarHeight}
                cartId={cartId}
                getSingleQuotationCartItems={getSingleQuotationCartItems}
              />
            )}

          {singleCartData?.owner === "PROJECT" && cartId && (
            <ProjectQuotationTable
              loading={
                singleQuotationLoading ||
                (cartItemsLoading && !cartSpecificProjectData?.length)
              }
              data={cartSpecificProjectData}
              cartSpecificProjectData={cartSpecificProjectData}
              setCartSpecificProjectData={setCartSpecificProjectData}
              calculateCost={calculateCost}
              selectedProject={selectedProject}
              showBanner={showBanner}
              enableCheckout={enableCheckout}
              projectSelectionIndex={projectSelectionIndex}
              setProjectSelectionIndex={setProjectSelectionIndex}
              bottomBarHeight={bottomBarHeight}
              quotationId={cartId}
              getSingleQuotationCartItems={getSingleQuotationCartItems}
              projectId={singleProjectData?.project?.id}
            />
          )}
        </div>
      </div>

      <BottomBar
        cost={cost}
        costLoading={costLoading}
        openModal={openModal}
        setOpenModal={setOpenModal}
        openFloorAreaModal={openFloorAreaModal}
        setOpenFloorAreaModal={setOpenFloorAreaModal}
        showProfessionalModal={showProfessionalModal}
        setShowProfessionalModal={setShowProfessionalModal}
        AddProductHandler={AddProductHandler}
        singleCartData={singleCartData}
        professional={selectedProfessional}
        handleDeleteProfessional={handleDeleteProfessional}
      />
      <AddProductModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        cartId={cartId}
        singleProjectData={singleProjectData}
        singleQuotationData={singleCartData}
        getSingleQuotationCartItems={getSingleQuotationCartItems}
      />
    </div>
  );
};

export default AbandonedCartDetails;
